"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isObjectEmpty = isObjectEmpty;
exports.hasOwnProperty = hasOwnProperty;
exports.getUniqueId = void 0;

var _nanoid = require("nanoid");

function isObjectEmpty(obj) {
  for (var _key in obj) {
    return false;
  }

  return true;
}
/*
  ESLint complains about:
    obj.hasOwnProperty(key)
  
  See: https://eslint.org/docs/rules/no-prototype-builtins
*/


function hasOwnProperty(obj, key) {
  return Object.prototype.hasOwnProperty.call(obj, key);
}

var getUniqueId = _nanoid.nanoid;
exports.getUniqueId = getUniqueId;